import { render } from "./DataExplorer.vue?vue&type=template&id=2cb7958c"
import script from "./DataExplorer.vue?vue&type=script&lang=ts"
export * from "./DataExplorer.vue?vue&type=script&lang=ts"
script.render = render

export default script